import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    value;
    clickChange;
    async addSimilarity() {
        if (this.value < 100) {
            this.$emit('input', +this.value + 1);
        }
        else {
            return;
        }
        await this.$nextTick();
        if (this.clickChange) {
            this.onChange(this.value);
        }
    }
    async redSimilarity() {
        if (this.value > 0) {
            this.$emit('input', +this.value - 1);
        }
        else {
            return;
        }
        await this.$nextTick();
        if (this.clickChange) {
            this.onChange(this.value);
        }
    }
    onNumberInput(v) {
        let value;
        if (typeof v === 'string') {
            value = (v.match(/^[0-9]+/g) && +v.match(/^[0-9]+/g)[0]) || '';
        }
        else
            value = v;
        this.$emit('input', +value);
    }
    onChange(v) {
        this.$emit('change', v);
    }
    onKeyUp(e) {
        if (e.code === 'Enter') {
            this.onChange(this.value);
        }
    }
    mounted() {
        if (!this.clickChange) {
            window.addEventListener('keyup', this.onKeyUp);
        }
    }
    beforeDestroy() {
        if (!this.clickChange) {
            window.removeEventListener('keyup', this.onKeyUp);
        }
    }
};
__decorate([
    Prop({ default: 0 })
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "clickChange", void 0);
default_1 = __decorate([
    Component({
        name: 'slider-input',
        components: {},
        i18n: {
            messages: {
                zh: {},
                en: {},
            },
        },
    })
], default_1);
export default default_1;
